import React, { useContext } from "react";
import { ButtonDS, GlobalIcon } from "get-life-storybook-ts";
import { I18nContext } from "../../../../../context/i18n.context";
import { translateOr } from "../../../../../components/HealthDataConsent/consentTexts";
import { GlobalTypeFormPolicy } from "../../../../../utils/InternationlChanges";

/**
 * Francia (Carlos, 5-nov-2026): el cliente no cambia sus beneficiarios desde el área de cliente.
 * La designación de las pólizas FR la escribe ms-scor y hoy solo entra por Operaciones (panel → ms-ops →
 * ms-scor), así que esta página no guarda nada: manda la solicitud al formulario de Operaciones, el mismo
 * de «Modifier mes données». Sustituye en FR a `BeneficiaryManager`, que enseñaba «guardado» sin enviar
 * nada. Los demás mercados no cambian.
 */
export const BENEFICIARY_REQUEST_FR_KEYS = {
  explain: "newDashboard.beneficiaryManager.fr.explain",
  notice: "newDashboard.beneficiaryManager.fr.notice",
  request: "newDashboard.beneficiaryManager.fr.request",
} as const;

// Textos de respaldo mientras las claves no estén en `getlife/translations` (docs/i18n-pending.md).
export const BENEFICIARY_REQUEST_FR_FALLBACKS = {
  explain:
    "Pour modifier la désignation de vos bénéficiaires, envoyez-nous votre demande. Notre équipe s'en charge et revient vers vous pour la finaliser.",
  notice:
    "La désignation de vos bénéficiaires ne change qu'une fois votre demande traitée par notre équipe.",
  request: "Faire ma demande",
} as const;

/** El mercado en el que los beneficiarios se piden a Operaciones en vez de editarse aquí. */
export const beneficiariesRequestedFromOperations = (domain?: string): boolean =>
  domain === "fr";

interface BeneficiaryRequestFrProps {
  onBack: () => void;
}

const BeneficiaryRequestFr = ({ onBack }: BeneficiaryRequestFrProps) => {
  const {
    state: { translate },
  } = useContext(I18nContext);
  const text = (field: keyof typeof BENEFICIARY_REQUEST_FR_KEYS) =>
    translateOr(
      translate,
      BENEFICIARY_REQUEST_FR_KEYS[field],
      BENEFICIARY_REQUEST_FR_FALLBACKS[field]
    );

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 24, maxWidth: 720 }}>
      <div>
        <button
          onClick={onBack}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 6,
            border: "none",
            background: "none",
            cursor: "pointer",
            color: "#6b7280",
            fontSize: 14,
            fontWeight: 500,
            padding: 0,
            marginBottom: 12,
          }}
        >
          <GlobalIcon iconName="ChevronDown" size="XS" color="#6b7280" />
          <span>{translate("newDashboard.beneficiaryManager.back")}</span>
        </button>
        <h1 style={{ fontSize: 24, fontWeight: 700, color: "#111827", margin: 0 }}>
          {translate("newDashboard.beneficiaryManager.title")}
        </h1>
        <p style={{ fontSize: 15, color: "#6b7280", marginTop: 4 }}>{text("explain")}</p>
      </div>

      <div
        style={{
          display: "flex",
          gap: 10,
          padding: 14,
          backgroundColor: "#fffbeb",
          borderRadius: 8,
          border: "1px solid #fef3c7",
        }}
      >
        <GlobalIcon iconName="InfoIcon" size="XS" color="#d97706" />
        <p style={{ fontSize: 14, color: "#92400e", margin: 0 }}>{text("notice")}</p>
      </div>

      <div>
        <ButtonDS
          label={text("request")}
          buttonType="primary"
          size="40"
          onClick={() =>
            window.open(GlobalTypeFormPolicy.fr, "_blank", "noopener,noreferrer")
          }
        />
      </div>
    </div>
  );
};

export default BeneficiaryRequestFr;
